import {dsDtos} from '@vectronic/openApi-customer'
import {Error} from './error'

export class Validate {
  static do(data: Buffer, vvr?: dsDtos.ValidValueRange) {
    if (!vvr) return true
    if (vvr.bytewise) return this.bytewise(data, vvr.bytewise)
    if (vvr.max || vvr.min) return this.interval(data, vvr)
    if (vvr.list) return this.list(data, vvr.list)
    return false
  }

  static firmware(minFirmwareVersion: dsDtos.Version, deviceFirmwareVersion?: dsDtos.FirmwareVersion) {
    if (!deviceFirmwareVersion) throw Error.PARAMETER_REQUIRES_FIRMWARE
    const {major, minor, release} = deviceFirmwareVersion.version!
    if (minFirmwareVersion.major! > major!) throw Error.FIRMWARE_VERSION_TOO_SMALL
    if (minFirmwareVersion.major! < major!) return
    if (minFirmwareVersion.minor! > minor!) throw Error.FIRMWARE_VERSION_TOO_SMALL
    if (minFirmwareVersion.minor! < minor!) return
    if (minFirmwareVersion.release! > release!) throw Error.FIRMWARE_VERSION_TOO_SMALL
  }

  static pcbType(configMinPcbType?: dsDtos.PcbType, devicePcbType?: dsDtos.PcbType) {
    if (!devicePcbType || !configMinPcbType) throw Error.PARAMETER_REQUIRES_PCBTYPE
    if (configMinPcbType.major! > devicePcbType.major!) throw Error.FIRMWARE_VERSION_TOO_SMALL
    if (configMinPcbType.major! < devicePcbType.major!) return
    if (configMinPcbType.minor! > devicePcbType.minor!) throw Error.FIRMWARE_VERSION_TOO_SMALL
  }

  static sameParameterId({id}: dsDtos.Parameter, {parameterId}: dsDtos.DeviceTypeParameterConfig) {
    if (parameterId !== id) throw Error.PARAMETER_MISSMATCH
  }

  private static list(data: Buffer, list: number[]) {
    const value = data.readUIntLE(0, data.length)
    return list.includes(value)
  }

  private static interval(data: Buffer, {max, min}: {max?: number; min?: number}) {
    const value = data.readUIntLE(0, data.length)
    if (max && value > max) return false
    if (min && value < min) return false
    return true
  }

  private static bytewise(data: Buffer, bytewise: string) {
    const vvrs = this.parseBytewise(bytewise)
    for (let i = 0; i < data.length; i++) if (!this.do(data.subarray(i, i + 1), vvrs[i])) return false
    return true
  }

  private static parseBytewise(bytewise: string) {
    return bytewise
      .split(';')
      .map((s) => {
        const pointSplit = s.split('.').map((str) => +str)
        if (pointSplit.length == 3) return {min: pointSplit[0], max: pointSplit[2]}
        const commaSplit = s.split(',').map((str) => +str)
        return {list: commaSplit}
      })
      .reverse()
  }
}
